import type { DateResolutionInput, DealInsightsChartInputApi } from '@openx/types/dealInsights.ts';

export const GENERAL_STATS_CARDS_COLUMNS_COUNT = 5;

export const GENERAL_STATS_CARDS_RESERVED_EMPTY_SLOTS = 1;

export const EXPORT_SECTION_OPTIONS = [
  {
    label: 'General',
    value: 'general',
  },
  {
    label: 'Distribution',
    value: 'distribution',
  },
  {
    label: 'Delivery',
    value: 'delivery',
  },
  {
    label: 'Geolocation',
    value: 'geolocation',
  },
];

export type ExportSectionId = 'general' | 'distribution' | 'delivery' | 'geolocation';

// Mapping from export section IDs to chart keys needed for that section
export const EXPORT_SECTION_CHART_KEYS: Record<ExportSectionId, (keyof DealInsightsChartInputApi)[]> = {
  general: ['general_stats', 'spend', 'bidrate_winrate', 'deal_stats'],
  distribution: ['inventory_distributions'],
  delivery: ['delivery_by_domain_bundle', 'delivery_by_ad_size', 'audiences', 'delivery_by_ad_duration'],
  geolocation: ['geolocation'],
};

// Default chart input values for each chart key when fetching for export
export const getDefaultChartInputForKey = (
  chartKey: keyof DealInsightsChartInputApi,
  chartDateResolutions: { spend: 'daily' | 'weekly' | 'monthly'; bidrate_winrate: 'daily' | 'weekly' | 'monthly' }
):
  | boolean
  | DateResolutionInput
  | { limit: number; offset: number; sort_field: string; sort_order: 'asc' | 'desc' } => {
  switch (chartKey) {
    case 'spend':
      return { include: true, date_resolution: chartDateResolutions.spend };
    case 'bidrate_winrate':
      return { include: true, date_resolution: chartDateResolutions.bidrate_winrate };
    case 'deal_stats':
      return { limit: 10, offset: 0, sort_field: 'impressions', sort_order: 'desc' };
    case 'delivery_by_domain_bundle':
    case 'audiences':
      return { limit: 10, offset: 0, sort_field: 'impressions', sort_order: 'desc' };
    case 'delivery_by_ad_size':
      return { limit: 21, offset: 0, sort_field: 'impressions', sort_order: 'desc' };
    default:
      return true;
  }
};
